import React, { Component } from "react"
import styles from "./Clock.module.scss"
import { getTime } from "lib/utils"

interface ClockState {
  date: Date
}
class Clock extends Component<unknown, ClockState> {
  state = {
    date: new Date(),
  }
  intervalID: NodeJS.Timeout | null = null

  componentDidMount = (): void => {
    this.intervalID = setInterval(() => this.tick(), 60000)
  }

  tick = (): void => {
    this.setState({
      date: new Date(),
    })
  }
  render = (): JSX.Element => (
    <div className={styles.Clock} data-testid="clock">
      {getTime(this.state.date)}
    </div>
  )
  componentWillUnmount = (): void => {
    if (this.intervalID) clearInterval(this.intervalID)
  }
}

export default Clock
